import { frontendURL } from '../../../helper/URLHelper';
import DriveIndex from './Index.vue';
import DriveReports from './Reports.vue';
import DriveRAG from './RAG.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/drive'),
    component: DriveIndex,
    name: 'drive_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/drive/reports'),
    component: DriveReports,
    name: 'drive_reports',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/drive/rag'),
    component: DriveRAG,
    name: 'drive_rag',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
